import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../../Containers/Config/index.js';
import { CANCEL_BOOKING_GOLF, CANCEL_BOOKING_GOLF_SUCCESS, CANCEL_BOOKING_GOLF_ERROR } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* cancelBookingGolf({ payload }) {
  try {
    const isUaeProject = ['CBD_GOLF_V2', 'VISA_PVT', 'MASTERCARD_UAE', 'MASHREQ'].includes(Constant?.PROJECT_CODE);
    const baseUrl = isUaeProject ? thriweMarketPlaceUaeUrl : thriweMarketPlaceUrl;
    const response = yield call(apiCall, {
      url: `${baseUrl}/v2/admin/cancel-booking/${payload?.urlParams?.booking_id}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CANCEL_BOOKING_GOLF_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CANCEL_BOOKING_GOLF_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CANCEL_BOOKING_GOLF_ERROR, payload: error });
  }
}

export function* watchCancelBookingGolf() {
  yield takeEvery(CANCEL_BOOKING_GOLF, cancelBookingGolf);
}

function* cancelBookingGolfSaga() {
  yield all([fork(watchCancelBookingGolf)]);
}

export default cancelBookingGolfSaga;
